<template>
    <v-container class="pa-2">
        <template v-if="maintain">
            <div class="d-flex justify-center align-center">
                <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
            </div>
        </template>
        <template v-else>
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-title>
                            <span class="headline">ตั้งค่าข้อมูลกิจกรรมเริ่มต้น ตำแหน่ง/อายุงาน</span>
                        </v-card-title>
                        <v-card-text>
                            <!-- Your content goes here -->
                            <v-list>
                                <v-list-item>
                                    <v-row class="justify-center">
                                        <v-col cols="12" class="d-flex justify-center">
                                            <v-radio-group v-model="dataSourceType" row class="justify-center" @change="chooseTypeCourse">
                                                <v-radio label="ข้อมูลจาก Binla Academy" value="medacademe"></v-radio>
                                                <v-radio label="ข้อมูลกำหนดเอง" value="custom"></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                    </v-row>
                                </v-list-item>
                                <template  v-if="dataSourceType === 'medacademe'">
                                    <v-list-item class="mb-4 justify-center">
                                        <v-row class="justify-center">
                                            <v-col cols="12" md="8">
                                                <v-text-field 
                                                    v-model="search" 
                                                    label="ค้นหากิจกรรม" 
                                                    clearable
                                                    prepend-inner-icon="mdi-magnify"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                    <v-list-item class="mb-4">
                                        <v-row class="justify-center">
                                            <v-col cols="12">
                                                <v-data-table 
                                                    :headers="headerCourseInit" 
                                                    :items="courseInitData"
                                                    :search="search" 
                                                    class="elevation-1" 
                                                    :items-per-page="5" 
                                                    :footer-props="{
                                                        itemsPerPageOptions: [5, 10, 15],
                                                        showFirstLastPage: true
                                                    }"
                                                >
                                                    <template #header.course_name>
                                                        <span style="font-size: 16px;font-weight: bold">ชื่องาน/กิจกรรม</span>
                                                    </template>
                                                    <template #item.course_name="{ item }">
                                                        <div>
                                                            <p class="mb-2" style="font-size: 16px;font-weight: bold">{{ item.course_name }}</p>
                                                            <v-btn 
                                                                text 
                                                                color="primary" 
                                                                class="darken-4 font-weight-bold" 
                                                                small
                                                                @click="openUrl(item)"
                                                            >
                                                                <v-icon left small>mdi-open-in-new</v-icon>
                                                                เปิดลิงค์กิจกรรม
                                                            </v-btn>
                                                        </div>
                                                    </template>
                                                    <template #header.action>
                                                        <span style="font-size: 16px;font-weight: bold">ทำรายการ</span>
                                                    </template>
                                                    <template #item.action="{ item }">
                                                        <v-btn 
                                                            color="primary" 
                                                            class="darken-4 font-weight-bold"
                                                            outlined
                                                            small
                                                            @click="openDialogSettingPositionData(item)"
                                                        >
                                                            <v-icon left small>mdi-cog</v-icon>
                                                            ตั้งค่าตำแหน่ง/อายุงาน
                                                        </v-btn>
                                                    </template>
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                </template>
                                <template  v-if="dataSourceType === 'custom'">
                                    <v-list-item class="mb-4">
                                        <v-row class="justify-center">
                                            <v-col cols="12" md="8" class="d-flex justify-center">
                                                <v-btn 
                                                    x-large
                                                    color="primary" 
                                                    class="darken-4 font-weight-bold mb-4"
                                                    @click="openDialogAddCustomCourse"
                                                >
                                                    <v-icon left>mdi-plus</v-icon>
                                                    เพิ่มข้อมูลกิจกรรมแบบกำหนดเอง
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                    <v-list-item class="mb-4">
                                        <v-row class="justify-center">
                                            <v-col cols="12" md="8">
                                                <v-text-field 
                                                    v-model="searchCustom" 
                                                    label="ค้นหากิจกรรมกำหนดเอง" 
                                                    clearable
                                                    prepend-inner-icon="mdi-magnify"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                    <v-list-item class="mb-4">
                                        <v-row class="justify-center">
                                            <v-col cols="12">
                                                <v-data-table 
                                                    :headers="headerCustomCourse" 
                                                    :items="customCourseData"
                                                    :search="searchCustom" 
                                                    class="elevation-1" 
                                                    :items-per-page="5" 
                                                    :footer-props="{
                                                        itemsPerPageOptions: [5, 10, 15],
                                                        showFirstLastPage: true
                                                    }"
                                                >
                                                    <template v-slot:header.course_name>
                                                        <span style="font-size: 16px;font-weight: bold">ชื่องาน/กิจกรรม</span>
                                                    </template>
                                                    <template v-slot:item.course_name="{ item }">
                                                        <div>
                                                            <div class="d-flex align-center mb-2">
                                                                <v-img 
                                                                    v-if="item.image_url"
                                                                    :src="item.image_url"
                                                                    max-width="80"
                                                                    max-height="60"
                                                                    class="mr-3"
                                                                ></v-img>
                                                                <div>
                                                                    <p class="mb-1" style="font-size: 16px;font-weight: bold">{{ item.course_name }}</p>
                                                                    <v-btn 
                                                                        text 
                                                                        color="primary" 
                                                                        class="darken-4 font-weight-bold" 
                                                                        small
                                                                        @click="openCustomUrl(item)"
                                                                    >
                                                                        <v-icon left small>mdi-open-in-new</v-icon>
                                                                        เปิดลิงค์กิจกรรม
                                                                    </v-btn>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template v-slot:header.action>
                                                        <span style="font-size: 16px;font-weight: bold">ทำรายการ</span>
                                                    </template>
                                                    <template v-slot:item.action="{ item }">
                                                        <v-btn 
                                                            color="primary" 
                                                            class="darken-4 font-weight-bold mb-2 mt-4"
                                                            outlined
                                                            small
                                                            @click="openDialogSettingPositionData(item)"
                                                        >
                                                            <v-icon left small>mdi-cog</v-icon>
                                                            ตั้งค่าตำแหน่ง/อายุงาน
                                                        </v-btn>
                                                        <div class="d-flex">
                                                            <v-btn 
                                                                color="orange" 
                                                                class="darken-4 font-weight-bold mr-2"
                                                                outlined
                                                                small
                                                                @click="editCustomCourse(item)"
                                                            >
                                                                <v-icon left small>mdi-pencil</v-icon>
                                                                แก้ไข
                                                            </v-btn>
                                                            <v-btn 
                                                                color="red" 
                                                                class="darken-4 font-weight-bold mb-4"
                                                                outlined
                                                                small
                                                                @click="deleteCustomCourse(item)"
                                                            >
                                                                <v-icon left small>mdi-delete</v-icon>
                                                                ลบ
                                                            </v-btn>
                                                        </div>
                                                    </template>
                                                </v-data-table>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>

                                    <!-- Dialog for adding/editing custom course -->
                                    <v-dialog v-model="dialogCustomCourse" max-width="600px" persistent>
                                        <v-card>
                                            <v-card-title>
                                                <span class="headline">{{ editingCustomCourse ? 'แก้ไขข้อมูลกำหนดเอง' : 'เพิ่มข้อมูลกำหนดเอง' }}</span>
                                            </v-card-title>
                                            <v-card-text>
                                                <v-form ref="customCourseForm" v-model="validCustomCourse">
                                                    <v-text-field
                                                        v-model="customCourseForm.course_name"
                                                        label="ชื่อเรื่อง/กิจกรรม"
                                                        :rules="[v => !!v || 'กรุณากรอกชื่อเรื่อง']"
                                                        required
                                                        outlined
                                                    ></v-text-field>
                                                    
                                                    <v-text-field
                                                        v-model="customCourseForm.url"
                                                        label="ลิงค์ URL"
                                                        :rules="[v => !!v || 'กรุณากรอกลิงค์', v => isValidUrl(v) || 'รูปแบบ URL ไม่ถูกต้อง']"
                                                        required
                                                        outlined
                                                    ></v-text-field>
                                                    
                                                    <v-file-input
                                                        v-model="customCourseForm.image_file"
                                                        label="อัพโหลดภาพประกอบ (ไม่บังคับ)"
                                                        accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
                                                        prepend-icon="mdi-camera"
                                                        outlined
                                                        show-size
                                                        @change="handleImageUpload"
                                                    ></v-file-input>

                                                    <v-checkbox
                                                        v-if="editingCustomCourse && customCourseForm.image_url && customCourseForm.image_file === null"
                                                        v-model="deleteImage"
                                                        label="ต้องการลบรูปภาพเดิม"
                                                        class="mb-3"
                                                        dense
                                                    ></v-checkbox>
                                                    
                                                    <v-card v-if="customCourseForm.image_url" class="mb-3">
                                                        <v-card-subtitle>ตัวอย่างภาพ:</v-card-subtitle>
                                                        <v-img 
                                                            :src="customCourseForm.image_url"
                                                            max-height="200"
                                                            contain
                                                            @error="imageError = true"
                                                            @load="imageError = false"
                                                        >
                                                            <template v-slot:placeholder>
                                                                <v-row class="fill-height ma-0" align="center" justify="center">
                                                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                                </v-row>
                                                            </template>
                                                        </v-img>
                                                        <v-alert v-if="imageError" type="warning" dense>
                                                            ไม่สามารถโหลดภาพได้ กรุณาตรวจสอบลิงค์ภาพ
                                                        </v-alert>
                                                    </v-card>
                                                    <div v-if="!customCourseForm.image_url" class="mb-3">
                                                        <v-card class="pa-4">
                                                            <v-card-subtitle>ตัวอย่างภาพ:</v-card-subtitle>
                                                            <div class="d-flex justify-center">
                                                                <svg width="400" height="200" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 400">
                                                                    <defs>
                                                                        <!-- Gradient backgrounds -->
                                                                        <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                                                            <stop offset="0%" style="stop-color:#667eea;stop-opacity:1" />
                                                                            <stop offset="100%" style="stop-color:#764ba2;stop-opacity:1" />
                                                                        </linearGradient>
                                                                        
                                                                        <!-- Text gradient -->
                                                                        <linearGradient id="textGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                                                            <stop offset="0%" style="stop-color:#667eea;stop-opacity:1" />
                                                                            <stop offset="50%" style="stop-color:#764ba2;stop-opacity:1" />
                                                                            <stop offset="100%" style="stop-color:#f093fb;stop-opacity:1" />
                                                                        </linearGradient>
                                                                        
                                                                        <!-- Line gradient -->
                                                                        <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                                                            <stop offset="0%" style="stop-color:#667eea;stop-opacity:1" />
                                                                            <stop offset="100%" style="stop-color:#764ba2;stop-opacity:1" />
                                                                        </linearGradient>
                                                                        
                                                                        <!-- Drop shadow filter -->
                                                                        <filter id="dropshadow" x="-50%" y="-50%" width="200%" height="200%">
                                                                            <feGaussianBlur in="SourceAlpha" stdDeviation="3"/>
                                                                            <feOffset dx="2" dy="4" result="offset" />
                                                                            <feComponentTransfer>
                                                                                <feFuncA type="linear" slope="0.3"/>
                                                                            </feComponentTransfer>
                                                                            <feMerge> 
                                                                                <feMergeNode/>
                                                                                <feMergeNode in="SourceGraphic"/> 
                                                                            </feMerge>
                                                                        </filter>
                                                                    </defs>
                                                                    
                                                                    <!-- Background -->
                                                                    <rect width="100%" height="100%" fill="url(#bgGradient)" rx="20"/>
                                                                    
                                                                    <!-- Background card -->
                                                                    <rect x="100" y="80" width="600" height="240" fill="rgba(255,255,255,0.95)" 
                                                                          rx="15" stroke="rgba(255,255,255,0.3)" stroke-width="1" 
                                                                          filter="url(#dropshadow)"/>
                                                                    
                                                                    <!-- Main text -->
                                                                    <text x="400" y="180" text-anchor="middle" 
                                                                          font-family="Sarabun, Arial, sans-serif" 
                                                                          font-size="72" 
                                                                          font-weight="700" 
                                                                          fill="url(#textGradient)"
                                                                          filter="url(#dropshadow)">
                                                                        คอร์สกิจกรรม
                                                                        <animateTransform attributeName="transform" type="scale" 
                                                                                          values="1;1.02;1" dur="3s" repeatCount="indefinite"/>
                                                                    </text>
                                                                    
                                                                    <!-- Decorative line -->
                                                                    <rect x="350" y="210" width="100" height="4" fill="url(#lineGradient)" rx="2">
                                                                        <animateTransform attributeName="transform" type="scale" 
                                                                                          values="1,1;1.1,1;1,1" dur="2s" repeatCount="indefinite"/>
                                                                    </rect>
                                                                    
                                                                    <!-- Subtitle -->
                                                                    <text x="400" y="250" text-anchor="middle" 
                                                                          font-family="Sarabun, Arial, sans-serif" 
                                                                          font-size="20" 
                                                                          font-weight="400" 
                                                                          fill="#666">
                                                                        Course Activities
                                                                    </text>
                                                                    
                                                                    <!-- Decorative elements -->
                                                                    <circle cx="150" cy="120" r="3" fill="rgba(255,255,255,0.6)">
                                                                        <animate attributeName="opacity" values="0.3;1;0.3" dur="2s" repeatCount="indefinite"/>
                                                                    </circle>
                                                                    <circle cx="650" cy="280" r="2" fill="rgba(255,255,255,0.5)">
                                                                        <animate attributeName="opacity" values="0.5;1;0.5" dur="1.5s" repeatCount="indefinite"/>
                                                                    </circle>
                                                                    <circle cx="180" cy="300" r="1.5" fill="rgba(255,255,255,0.4)">
                                                                        <animate attributeName="opacity" values="0.2;0.8;0.2" dur="2.5s" repeatCount="indefinite"/>
                                                                    </circle>
                                                                </svg>
                                                            </div>
                                                        </v-card>
                                                    </div>
                                                </v-form>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="grey darken-1" text @click="closeDialogCustomCourse">ยกเลิก</v-btn>
                                                <v-btn 
                                                    color="primary darken-1" 
                                                    text 
                                                    @click="saveCustomCourse"
                                                    :disabled="!validCustomCourse"
                                                >
                                                    {{ editingCustomCourse ? 'บันทึก' : 'เพิ่ม' }}
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </template>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-dialog v-model="dialogSettingPosition" full-screen persistent>
                <v-card>
                    <v-card-title class="headline" v-if="courseInitObj != null">
                        <span>ชื่องาน/กิจกรรม : {{ courseInitObj.course_name }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-list>
                            <v-list-item>
                                <v-row class="justify-center">
                                    <v-col cols="10" md="5">
                                        <v-autocomplete v-model="positionSel" :items="PositionsData" item-text="PosName"
                                            item-value="PosCode" label="ค้นหา ตำแหน่ง" clearable hide-details
                                            prepend-inner-icon="mdi-magnify" multiple class="mb-4"
                                            :disabled="isCheckPositionAll"
                                            :error="positionSel.length == 0 && !isCheckPositionAll"
                                            :error-messages="positionSel.length == 0 && !isCheckPositionAll ? 'กรุณาเลือกตำแหน่ง' : ''"
                                            ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="2" md="1">
                                        <v-checkbox v-model="isCheckPositionAll" label="ทั้งหมด"></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                            <v-list-item>
                                <v-row class="justify-center">
                                    <v-col cols="10" md="2">
                                        <v-autocomplete :items="ageStart" v-model="ageStartSel" label="อายุงานเริ่มต้น"
                                            :disabled="isCheckWorkAgeStartAll"
                                            :error="ageStartSel == null && !isCheckWorkAgeStartAll"
                                            :error-messages="ageStartSel == null && !isCheckWorkAgeStartAll ? 'กรุณาเลือกอายุงานเริ่มต้น' : ''"
                                            ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="2" md="2">
                                        <v-checkbox v-model="isCheckWorkAgeStartAll" label="ไม่กำหนด"></v-checkbox>
                                    </v-col>
                                    <v-col cols="10" md="2">
                                        <v-autocomplete :items="ageEnd" v-model="ageEndSel" label="อายุงานสิ้นสุด"
                                            :disabled="isCheckWorkAgeEndAll"
                                            :error="ageEndSel == null && !isCheckWorkAgeEndAll"
                                            :error-messages="ageEndSel == null && !isCheckWorkAgeEndAll ? 'กรุณาเลือกอายุงานสิ้นสุด' : ''"
                                            ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="2" md="2">
                                        <v-checkbox v-model="isCheckWorkAgeEndAll" label="ไม่กำหนด"></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item class="justify-center mt-4">
                                <v-btn color="primary" class="darken-4 font-weight-bold"
                                    @click="insertCourseData()">เพิ่มข้อมูล</v-btn>
                            </v-list-item>
                            <v-divider></v-divider>
                            <v-list-item class="justify-center mt-4">
                                <v-spacer></v-spacer>
                                <v-text-field text class="darken-4 font-weight-bold" v-model="searchCourseInitSetting" label="ค้นหา"></v-text-field>
                            </v-list-item>
                            <v-list-item class="justify-center mt-4">
                                <v-row class="justify-center">
                                    <v-col cols="12" md="8">
                                        <v-data-table :headers="headerCourseInitSetting" :items="courseInitSettingData"
                                            :search="searchCourseInitSetting" class="elevation-1" :items-per-page="5">
                                            <template v-slot:header.position>
                                                <span style="font-size: 16px;font-weight: bold">ตำแหน่ง</span>
                                            </template>
                                            <template v-slot:item.position="{ item }">
                                                <span style="font-size: 16px;font-weight: bold">{{ item.position }}</span>
                                            </template>
                                            <template v-slot:header.age_start>
                                                <span style="font-size: 16px;font-weight: bold">อายุงานเริ่มต้น</span>
                                            </template>
                                            <template v-slot:item.age_start="{ item }">
                                                <span style="font-size: 16px;font-weight: bold">{{ item.age_start }}</span>
                                            </template>
                                            <template v-slot:header.age_end>
                                                <span style="font-size: 16px;font-weight: bold">อายุงานสิ้นสุด</span>
                                            </template>
                                            <template v-slot:item.age_end="{ item }">
                                                <span style="font-size: 16px;font-weight: bold">{{ item.age_end }}</span>
                                            </template>
                                            <template v-slot:header.action>
                                                <span style="font-size: 16px;font-weight: bold">การกระทำ</span>
                                            </template>
                                            <template v-slot:item.action="{ item }">
                                                <v-btn text color="red" class="darken-4 font-weight-bold"
                                                    @click="deleteCourseInitSetting(item)">ลบ</v-btn>
                                            </template>
                                        </v-data-table>

                                    </v-col>
                                </v-row>
                            </v-list-item>
                        </v-list>
                        <v-row>
                            <v-col cols="12">

                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark color="red darken-1 font-weight-bold" @click="dialogSettingPosition = false">ปิด</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogLoading" persistent max-width="400px">
                <v-card>
                    <v-card-title class="headline">
                        <span>กำลังดำเนินการ</span>
                    </v-card-title>
                    <v-card-text class="text-center">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </template>
    </v-container>

</template>

<script>
import Const from "@/const/Const";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import ConstData from "@/const/Const";

export default {
    name: 'SettingTrainOfPersonal',
    data() {
        return {
            // Define your data properties here
            // Custom course related data
            deleteImage: false,
            courseCustomObj: null,
            customCourseData: [],
            searchCustom: '',
            dialogCustomCourse: false,
            editingCustomCourse: false,
            validCustomCourse: false,
            imageError: false,
            customCourseForm: {
                course_name: '',
                url: '',
                image_url: ''
            },
            headerCustomCourse: [
                { text: 'ชื่องาน/กิจกรรม', value: 'course_name' },
                { text: '', value: 'action' },
            ],
            dataSourceType: 'medacademe', // 'medacademe' or 'custom'
            courseInitSettingData: [],
            searchCourseInitSetting: '',
            positionSel: [],
            isCheckWorkAgeStartAll: false,
            isCheckWorkAgeEndAll: false,
            isCheckPositionAll: false,
            ageStartSel: null,
            ageEndSel: null,
            ageStart: [],
            ageEnd: [],
            courseInitObj: null,
            dialogSettingPosition: false,
            courseInitData: [],
            maintain: false,
            page: null,
            dialogLoading: false,
            pageMessage: '',
            CheckAdmin: false,
            CheckSubAdmin: false,
            expenseObj: null,
            dialogEdit: false,
            dialogProcess: false,
            search: '',
            headerPosition: {
                position: "ตำแหน่ง",
                department: "แผนก",
                status: "สถานะ",
                action: "การกระทำ"
            },
            headerCourseInit: [
                { text: 'ชื่องาน/กิจกรรม', value: 'course_name' },
                { text: '', value: 'action' },
            ],
            headerCourseInitSetting: [
                { text: 'ตำแหน่ง', value: 'position' },
                { text: 'อายุงานเริ่มต้น', value: 'age_start' },
                { text: 'อายุงานสิ้นสุด', value: 'age_end' },
                { text: '', value: 'action' }
            ],

        };
    },
    computed: {
        // Define your computed properties here
        ...mapGetters({
            MeData: 'Staff/getMeData',
            PositionsData: 'Positions/getPosition',
            AllDepPermission: 'Permission/getAllDepUserPermission',
            DepPermission: 'Permission/getDepUserPermission',
            AllPermission: 'Permission/getAllUserPermission',
            Permission: 'Permission/getPermissionUser',
            Permission_Ms: 'Permission/getPermissionMs',
            Permission_Dep_User: 'Permission/getPermissionDepUser',
            Permission_Dep: 'Permission/getPermissionDep',
            Approve_Ms: 'Permission/getApproveMs',
            Approve: 'Permission/getApprove',
            PermissionAdmin: 'Permission/getPermission',
            MenuPermiss: 'Permission/getMenuPermiss',
            IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
            DateForPlan: 'Project/getDateForPlan',
            TypeProject: 'Project/getTypeProject',
            expense_Data: 'Project/getExpense',
            courseInitSetting: 'Project/getCourseInitSetting',
            appColor: 'Page/getColor',
            appHeaderName: 'Page/getHeaderName',
        }),
    },
    watch: {
    },
    methods: {
        // Define your methods here
        ...mapActions({
            initMeData: 'Staff/initMeData',
            initPositionData: 'Positions/initPositionData',
            initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
            initPermissionDepUserData: 'Permission/initPermissionDepUserData',
            initPermissionUserData: 'Permission/initPermissionUserData',
            initPermissionMsData: 'Permission/initPermissionMsData',
            getPermissionUserData: 'Permission/getPermissionUserData',
            getPermissionDep: 'Permission/getPermissionDepData',
            initPermissionDepData: 'Permission/initPermissionDepData',
            getPermissionDepUserData: 'Permission/getPermissionDepUserData',
            initApproveMsData: 'Permission/initApproveMsData',
            initApproveData: 'Permission/initApproveData',
            getPermissionData: 'Permission/getPermissionData',
            initPermissionData: 'Permission/initPermissionData',
            getMenuPermissData: 'Permission/getMenuPermissData',
            getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
            initDateForPlan: 'Project/initDateForPlan',
            changeTypeProject: 'Project/changeTypeProject',
            initExpenseData: 'Project/initExpenseData',
            initCourseInitSetting: 'Project/initCourseInitSetting',
            changeColor: 'Page/changeColor',
            changeHeaderName: 'Page/changeHeaderName',
        }),
        init() {
            this.courseInitData = []
            this.addWorkAge();
            this.initPositionData()
            this.chooseTypeCourse()
        },
        chooseTypeCourse() {
            // เช็คว่า dataSourceType เป็น 'medacademe' หรือ 'custom'
            if (this.dataSourceType === 'medacademe') {
                this.initCourseInitSetting({
                    permiss_check: this.MeData[0].perid
                }).then(res => {
                    if (res) {
                        if (this.courseInitSetting.length > 0) {
                            this.courseInitSetting.map((item) => {
                                this.courseInitData.push({
                                    course_name: item.title.rendered,
                                    link: item.link,
                                    id: item.id,
                                })
                            })
                        } else {
                            this.dialogProcess = false
                        }
                    }
                })
            } else if (this.dataSourceType === 'custom') {
                this.initCourseCustomInitData();
            }
        },
        addWorkAge() {
            this.ageStart = []
            this.ageEnd = []
            for (let i = 0; i < 99; i++) {
                this.ageStart.push({
                    text: i + 1,
                    value: i + 1
                })
                this.ageEnd.push({
                    text: i + 1,
                    value: i + 1
                })
            }
            /* this.ageStart.unshift({
                text: 'ไม่กำหนด',
                value: '-'
            })
            this.ageEnd.unshift({
                text: 'ไม่กำหนด',
                value: '-'
            }) */

        },
        openUrl(item) {
            window.open(item.link, '_blank');
        },
        ChooseProcess(page) {
            this.page = null
            this.page = page
            this.expenseDataDump = []
            if (page == '1') {
                this.changeTypeProject({
                    type: '1'
                })
                this.changeColor({
                    color: '#1976d2'
                })
                this.changeHeaderName({
                    headerName: Const.defaultHeaderApp1
                })
                this.dialogProcess = false
            } else {
                this.changeTypeProject({
                    type: '2'
                })
                this.changeColor({
                    color: '#004D40'
                })
                this.changeHeaderName({
                    headerName: Const.defaultHeaderApp2
                })
                this.dialogProcess = false
            }
        },

        openDialogSettingPositionData(item) {
            this.courseInitObj = null
            this.courseInitObj = item
            this.positionSel = []
            this.ageStartSel = null
            this.ageEndSel = null
            this.isCheckPositionAll = false
            this.isCheckWorkAgeStartAll = false
            this.isCheckWorkAgeEndAll = false
            this.dialogSettingPosition = true
            this.updateTblCourseInitForPosisionSetting()
        },
        insertCourseData() {
            /* this.$swal.fire({
                title: 'ยืนยันการทำรายการ',
                text: "ต้องการเพิ่มรายการค่าใช้จ่าย " + this.expense
                + " (" + this.appHeaderName + " ) ใช่หรือไม่ ?" ,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                if (result.value) {

                }
            }) */
            this.dialogLoading = true
            axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php", {
                queryName: "saveDataCourseInitSetting",
                param: btoa(
                    encodeURIComponent(
                        JSON.stringify({
                            course_id: this.courseInitObj.id,
                            position: this.isCheckPositionAll ? 'all' : this.positionSel,
                            age_start: this.isCheckWorkAgeStartAll ? 'all' : this.ageStartSel,
                            age_end: this.isCheckWorkAgeEndAll ? 'all' : this.ageEndSel,
                            is_type: this.dataSourceType === 'medacademe' ? '1' : '2',
                            permiss_check: this.MeData[0].perid
                        })
                    )
                ),
            }).then(res => {
                if (res.data.status) {
                    this.dialogLoading = false
                    this.$swal.fire({
                        icon: 'success',
                        title: 'เพิ่มข้อมูลสำเร็จ',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    // this.dialogSettingPosition = false
                    this.positionSel = []
                    this.ageStartSel = null
                    this.ageEndSel = null
                    this.isCheckPositionAll = false
                    this.isCheckWorkAgeStartAll = false
                    this.isCheckWorkAgeEndAll = false
                    this.updateTblCourseInitForPosisionSetting()
                } else {
                    this.dialogLoading = false
                    this.$swal.fire({
                        icon: 'error',
                        title: 'เกิดข้อผิดพลาด',
                        text: res.data.message,
                        confirmButtonText: 'ตกลง'
                    })
                }
            }).catch(err => {
                console.error(err)
                this.dialogLoading = false
                this.$swal.fire({
                    icon: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: 'ไม่สามารถเพิ่มข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
                    confirmButtonText: 'ตกลง'
                })
            })
        },
        updateTblCourseInitForPosisionSetting() {
            this.dialogLoading = true
            this.courseInitSettingData = []
            axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php", {
                queryName: "getCourseInitSettingForPosition",
                param: btoa(
                    encodeURIComponent(
                        JSON.stringify({
                            id: this.courseInitObj.id,
                            permiss_check: this.MeData[0].perid
                        })
                    )
                ),
            }).then(res => {
                if (res.data.length > 0) {
                    res.data.map((item) => {
                        this.courseInitSettingData.push({
                            position: item.is_check_all_position == '1' ? 'ทุกตำแหน่ง' : item.PosCode == null ? '-' : this.PositionsData.filter(pos => pos.PosCode == item.PosCode)[0].PosName,
                            age_start: item.is_check_age_start == '1' ? 'ไม่กำหนด' : item.age_start == null ? '-' : item.age_start,
                            age_end: item.is_check_age_end == '1' ? 'ไม่กำหนด' : item.age_end == null ? '-' : item.age_end,
                            course_id: item.course_id,
                            id: item.id
                        })
                    })
                } else {
                    this.courseInitSettingData = []
                }
            }).catch(err => {
                console.error(err)
                this.dialogLoading = false
                this.$swal.fire({
                    icon: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: 'ไม่สามารถเพิ่มข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
                    confirmButtonText: 'ตกลง'
                })
            }).finally(() => {
                this.dialogLoading = false
            });
        },
        deleteCourseInitSetting(item) {
            this.$swal.fire({
                title: 'ยืนยันการลบข้อมูล',
                text: "ต้องการลบรายการนี้ใช่หรือไม่ ?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                if (result.value) {
                    this.dialogLoading = true
                    axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php", {
                        queryName: "deleteCourseInitSetting",
                        param: btoa(
                            encodeURIComponent(
                                JSON.stringify({
                                    id: item.id,
                                    permiss_check: this.MeData[0].perid
                                })
                            )
                        ),
                    }).then(res => {
                        if (res.data.status) {
                            this.dialogLoading = false
                            this.$swal.fire({
                                icon: 'success',
                                title: 'ลบข้อมูลสำเร็จ',
                                showConfirmButton: false,
                                timer: 1500
                            })
                            this.updateTblCourseInitForPosisionSetting()
                        } else {
                            this.dialogLoading = false
                            this.$swal.fire({
                                icon: 'error',
                                title: 'เกิดข้อผิดพลาด',
                                text: res.data.message,
                                confirmButtonText: 'ตกลง'
                            })
                        }
                    }).catch(err => {
                        console.error(err)
                        this.dialogLoading = false
                        this.$swal.fire({
                            icon: 'error',
                            title: 'เกิดข้อผิดพลาด',
                            text: 'ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
                            confirmButtonText: 'ตกลง'
                        })
                    })
                }
            })
        },
        openDialogAddCustomCourse() {
            // เคลียร์ฟอร์มก่อนเปิด dialog
            this.customCourseForm = {
                course_name: '',
                url: '',
                image_file: null,
                image_url: ''
            };
            this.dialogCustomCourse = true
        },
        closeDialogCustomCourse() {
            this.dialogCustomCourse = false
        },
        handleImageUpload() {
            this.deleteImage = false;
            if (this.customCourseForm.image_file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.customCourseForm.image_url = e.target.result;
                    this.imageError = false;
                };
                reader.onerror = () => {
                    this.imageError = true;
                    this.customCourseForm.image_url = '';
                };
                reader.readAsDataURL(this.customCourseForm.image_file);
            } else {
                this.customCourseForm.image_url = '';
                this.imageError = false;
            }
        },
        uploadFile() {
            return new Promise((resolve, reject) => {
            if (this.customCourseForm.image_file) {
                // ตรวจสอบประเภทไฟล์
                const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
                if (!allowedTypes.includes(this.customCourseForm.image_file.type)) {
                this.$swal.fire({
                    icon: 'error',
                    title: 'ประเภทไฟล์ไม่ถูกต้อง',
                    text: 'กรุณาเลือกไฟล์รูปภาพเท่านั้น (JPEG, JPG, PNG, GIF, WEBP)',
                    confirmButtonText: 'ตกลง'
                });
                reject('Invalid file type');
                return;
                }

                const fd = new FormData();
                fd.append('file', this.customCourseForm.image_file, this.customCourseForm.image_file.name);
                const headerAxios = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'WithCredentials': true,
                    "Access-Control-Allow-Origin": "*"
                }
                };

                axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
                if (res.data.status) {
                    this.customCourseForm.image_url = res.data.path;
                    this.imageError = false;
                    resolve({
                    status: true,
                    fileData: {
                        new_name: this.generateUUID(),
                        name: this.customCourseForm.image_file.name,
                        src: URL.createObjectURL(this.customCourseForm.image_file),
                        path: res.data.path,
                        type: this.customCourseForm.image_file.type,
                        type_Img: this.customCourseForm.image_file.type
                    },
                    });
                } else {
                    this.$swal.fire({
                    icon: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: res.data.message,
                    confirmButtonText: 'ตกลง'
                    });
                    reject(res.data.message);
                }
                }).catch(err => {
                console.error(err);
                this.$swal.fire({
                    icon: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: 'ไม่สามารถอัพโหลดไฟล์ได้ กรุณาลองใหม่อีกครั้ง',
                    confirmButtonText: 'ตกลง'
                });
                reject(err);
                });
            } else {
                resolve({
                status: true,
                fileData: null
                });
            }
            });
        },
        saveCustomCourse() {
            if (this.$refs.customCourseForm.validate()) {
                this.$swal.fire({
                    title: 'ยืนยันการทำรายการ',
                    text: this.editingCustomCourse ? 
                        "ต้องการแก้ไขข้อมูลกิจกรรม '" + this.customCourseForm.course_name + "' ใช่หรือไม่?" : 
                        "ต้องการเพิ่มข้อมูลกิจกรรม '" + this.customCourseForm.course_name + "' ใช่หรือไม่?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText: 'ยกเลิก'
                }).then((result) => {
                    if (result.value) {
                        this.dialogLoading = true
                        this.uploadFile().then(res => {
                            let formData;
                            if (res.fileData != null) {
                                formData = {
                                    id: this.editingCustomCourse ? this.courseCustomObj.id : null,
                                    title: this.customCourseForm.course_name,
                                    url: this.customCourseForm.url,
                                    image_path: res.fileData.path,
                                    image_new_name: res.fileData.new_name,
                                    image_old_name: res.fileData.name,
                                    image_type: res.fileData.type,
                                    permiss_check: this.MeData[0].perid
                                };
                            } else {
                                formData = {
                                    id: this.editingCustomCourse ? this.courseCustomObj.id : null,
                                    title: this.customCourseForm.course_name,
                                    url: this.customCourseForm.url,
                                    image_path: this.deleteImage ? null : (this.courseCustomObj?.image_path || null),
                                    image_new_name: this.deleteImage ? null : (this.courseCustomObj?.image_new_name || null),
                                    image_old_name: this.deleteImage ? null : (this.courseCustomObj?.image_old_name || null),
                                    image_type: this.deleteImage ? null : (this.courseCustomObj?.image_type || null),
                                    permiss_check: this.MeData[0].perid
                                };
                            }

                            axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php", {
                                queryName: this.editingCustomCourse ? "updateCustomCourseInitSetting" : "saveCustomCourseInitSetting",
                                param: btoa(encodeURIComponent(JSON.stringify(formData))),
                            }).then(res => {
                                if (res.data.status) {
                                    this.dialogLoading = false
                                    this.$swal.fire({
                                        icon: 'success',
                                        title: 'บันทึกข้อมูลสำเร็จ',
                                        showConfirmButton: false,
                                        timer: 1500
                                    })
                                    this.dialogCustomCourse = false
                                    this.customCourseData = res.data.data;
                                    if (this.customCourseData.length > 0) {
                                        this.customCourseData.map((item) => {
                                            item.course_name = item.title;
                                        })
                                    }
                                } else {
                                    this.dialogLoading = false
                                    this.$swal.fire({
                                        icon: 'error',
                                        title: 'เกิดข้อผิดพลาด',
                                        text: res.data.message,
                                        confirmButtonText: 'ตกลง'
                                    })
                                }
                            }).catch(err => {
                                console.error(err)
                                this.dialogLoading = false
                                this.$swal.fire({
                                    icon: 'error',
                                    title: 'เกิดข้อผิดพลาด',
                                    text: 'ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
                                    confirmButtonText: 'ตกลง'
                                })
                            })
                        }).catch(err => {
                            console.error(err);
                            this.dialogLoading = false;
                            return;
                        });
                    }
                })
            } else {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'ข้อมูลไม่ครบถ้วน',
                    text: 'กรุณากรอกข้อมูลให้ครบถ้วนก่อนทำการบันทึก',
                    confirmButtonText: 'ตกลง'
                });
            }
        },
        generateUUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        isValidUrl(url) {
            const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
                '((([a-z0-9\\-]+\\.)+[a-z]{2,})|'+ // domain name
                'localhost|'+ // localhost
                '\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}|'+ // IP
                '\\[?[a-f0-9:\\.]+\\]?)'+ // IPv6
                '(\\:\\d+)?(\\/[^\\s]*)?$','i'); // port and path
            return pattern.test(url);
        },
        openCustomUrl(item) {
            if (this.isValidUrl(item.url)) {
                window.open(item.url, '_blank');
            } else {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'URL ไม่ถูกต้อง',
                    text: 'กรุณาตรวจสอบ URL ที่กรอก',
                    confirmButtonText: 'ตกลง'
                });
            }
        },
        initCourseCustomInitData() {
            this.customCourseData = [];
            this.dialogLoading = true
            axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php", {
                queryName: "getCustomCourseInitSetting",
                param: btoa(
                    encodeURIComponent(
                        JSON.stringify({
                            permiss_check: this.MeData[0].perid
                        })
                    )
                ),
            }).then(res => {
                if (res.data.status) {
                    this.customCourseData = res.data.data;
                    if (this.customCourseData.length > 0) {
                        this.customCourseData.map((item) => {
                            item.course_name = item.title;
                        })
                    }
                }
            }).catch(err => {
                console.error(err)
                this.$swal.fire({
                    icon: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: 'ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้ง',
                    confirmButtonText: 'ตกลง'
                })
            }).finally(() => {
                this.dialogLoading = false
            });
        },
        editCustomCourse(item) {
            this.courseCustomObj = item;
            this.deleteImage = false;
            this.customCourseForm = {
                course_name: item.course_name,
                url: item.url,
                image_file: null,
                image_url: item.image_path != null ? ConstData.ConnectionHost + "rest/files" + item.image_path : null
            };
            this.editingCustomCourse = true;
            this.dialogCustomCourse = true;
            this.imageError = false;
        },
        deleteCustomCourse(item) {
            this.$swal.fire({
                icon: 'warning',
                title: 'ยืนยันการลบ',
                text: 'คุณต้องการลบกิจกรรมนี้ใช่หรือไม่?',
                showCancelButton: true,
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then(result => {
                if (result.value) {
                    this.dialogLoading = true;
                    axios.post(ConstData.ConnectionHost + "/HrTrain2/serviceAPI.php", {
                        queryName: "deleteCustomCourseInitSetting",
                        param: btoa(
                            encodeURIComponent(
                                JSON.stringify({
                                    id: item.id,
                                    permiss_check: this.MeData[0].perid
                                })
                            )
                        ),
                    }).then(res => {
                        if (res.data.status) {
                            this.$swal.fire({
                                icon: 'success',
                                title: 'ลบข้อมูลกิจกรรมสำเร็จ',
                                confirmButtonText: 'ตกลง'
                            });
                            // this.initCourseCustomInitData();
                            this.customCourseData = res.data.data;
                            if (this.customCourseData.length > 0) {
                                this.customCourseData.map((item) => {
                                    item.course_name = item.title;
                                })
                            }
                        } else {
                            this.$swal.fire({
                                icon: 'error',
                                title: 'เกิดข้อผิดพลาด',
                                text: res.data.message,
                                confirmButtonText: 'ตกลง'
                            });
                        }
                    }).catch(err => {
                        console.error(err);
                        this.$swal.fire({
                            icon: 'error',
                            title: 'เกิดข้อผิดพลาด',
                            text: 'ไม่สามารถลบหลักสูตรได้ กรุณาลองใหม่อีกครั้ง',
                            confirmButtonText: 'ตกลง'
                        });
                    }).finally(() => {
                        this.dialogLoading = false;
                    });
                }
            });
        }
    },
    mounted() {
        this.changeColor({
            color: Const.defaultColorApp
        })
        this.changeHeaderName({
            headerName: Const.defaultHeaderApp
        })
        this.changeTypeProject({
            type: null
        })
        this.initMeData().then(async res => {
            if (res) {
                await this.getIgnoreMenuPermissData({
                    perid: this.MeData[0].perid,
                    page_id: '25'
                })
                this.getMenuPermissData().then(async res => {
                    if (res) {
                        if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '25' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
                            this.maintain = false
                            this.dialogLoading = true
                            this.getPermissionData({
                                perid: this.MeData[0].perid
                            }).then(resAdmin => {
                                if (resAdmin) {
                                    this.PermissionAdmin.map((Per_i, idx) => {
                                        if (Per_i.permission_id == '18000') {
                                            this.CheckAdmin = true
                                            this.dialogLoading = false
                                            this.init()
                                        } else {
                                            this.dialogLoading = false
                                            if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                                                this.$router.push('/')
                                            }
                                        }
                                    })
                                } else {
                                    this.getPermissionUserData({
                                        perid: this.MeData[0].perid
                                    }).then(resUser => {
                                        if (resUser) {
                                            this.Permission.map((Per_i, idx) => {
                                                if (Per_i.permission_id == '18000') {
                                                    this.CheckSubAdmin = true
                                                    this.dialogLoading = false
                                                    this.init()
                                                } else {
                                                    this.dialogLoading = false
                                                    if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                                                        this.$router.push('/')
                                                    }
                                                }
                                            })
                                        } else {
                                            this.dialogLoading = false
                                            this.CheckSubAdmin = false
                                            this.CheckAdmin = false
                                            this.$router.push('/')
                                        }
                                    })
                                }
                            })
                        } else {
                            this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '25' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '25')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                            this.maintain = true
                        }
                    }
                }).then(err => {
                    if (err) {
                        this.pageMessage = this.MenuPermiss.filter(item => item.page_id == '25' && item.page_message != null).length > 0 ? this.MenuPermiss.filter(item => item.page_id == '25')[0].page_message : 'ปิดปรับปรุงระบบชั่วคราว'
                        this.maintain = true
                    }
                })
            }
        }).catch(reason => {
            this.dialogLoading = false
            console.log('Reject = ' + reason)
        })
    }
}
</script>

<style scoped></style>